module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.14793/js/img/OperationsHub_Icon.svg"